import { Team } from "@brg/api";

export enum RepostTabs {
    feed = 'feed',
    mediiia = 'mediiiia',
    delete = 'delete'
}

export enum REPOST_MODE {
    add = 'add',
    edit = 'edit',
    delete = 'delete'
}

export const DEFAULT_TABS = [
    {
        value: RepostTabs.feed,
        name: [{ lang: 'ru', name: 'Материалы подписок'}, { lang: 'en', name: 'feed'}]
    },
];

export const getFindTab = (arr: Team<'Global'>[], projectId: string) => {
    const channel = arr?.find((i) => i?.tabs?.find((tab) => tab?.filter?.projectIds?.includes(projectId)))
    const tab = channel?.tabs?.find((tab) => tab?.filter?.projectIds?.includes(projectId))
    return tab
}

export type OptionWithAddT = {
    label: string,
    value: string,
    addOptions: any[]
}

export type OptionActiveT= {
    label: string,
    value: string,
    parent: {
        label: string,
        value: string,
    }
}import { Team } from "@brg/api";

export enum RepostTabs {
    feed = 'feed',
    mediiia = 'mediiiia',
    delete = 'delete'
}

export enum REPOST_MODE {
    add = 'add',
    edit = 'edit',
    delete = 'delete'
}

export const DEFAULT_TABS = [
    {
        value: RepostTabs.feed,
        name: [{ lang: 'ru', name: 'Материалы подписок'}, { lang: 'en', name: 'feed'}]
    },
];

export const getFindTab = (arr: Team<'Global'>[], projectId: string) => {
    const channel = arr?.find((i) => i?.tabs?.find((tab) => tab?.filter?.projectIds?.includes(projectId)))
    const tab = channel?.tabs?.find((tab) => tab?.filter?.projectIds?.includes(projectId))
    return tab
}

export type OptionWithAddT = {
    label: string,
    value: string,
    addOptions: any[]
}

export type OptionActiveT= {
    label: string,
    value: string,
    parent: {
        label: string,
        value: string,
    }
}